import React from 'react';
import PropTypes from 'prop-types'
import moment from 'moment';
import { Button, Container, Form, Label, Segment } from 'semantic-ui-react';
import { licensePropType } from '_utils/licenses';
import { formatDate, getFsUrl } from '_utils';
import { STATUS } from '../../../server/constants';
import useCanAdminLicenses from '../../hooks/useCanAdminLicenses';
import LineItem from '_views/lineItem';
import { PAGES } from '_constants';

const confirmDowngrade = (onDowngrade, payload) => _e => {
  if (window.confirm('Downgrade this License Upgrade?')) onDowngrade(payload);
};

const LicenseUpgradeInfo = ({
  license,
  onDeactivateLicenseUpgrade,
  setNavigation,
}) => {
  const canAdminLicense = useCanAdminLicenses();

  if (!license.license_upgrades || !license.license_upgrades.length) {
    return null;
  }

  const lastDowngradableLicense = license.license_upgrades.reduce((last, lu) => {
    if (lu.status !== STATUS.ACTIVE || lu.upgrade_fastspring_product) {
      return last;
    }
    return !last || moment(last.activated_on).isBefore(lu.activated_on) ? lu : last;
  }, null);

  return (
    <Segment.Group>
      {license.license_upgrades.map((upgrade) => (
        <Segment tertiary={upgrade.status === STATUS.NOT_ACTIVE} key={upgrade._id}>
          <Form as={Container} size="tiny">
            <Form.Group>
              <Form.Input width={8} label="Upgraded From" name="from" value={upgrade.upgraded_from} readOnly />
              <Form.Input width={8} label="Upgraded To" name="to" value={upgrade.upgraded_to} readOnly />
            </Form.Group>
            <Form.Group>
              <Form.Input width={8} label="Status" name="status" value={upgrade.status} readOnly />
              <Form.Input width={8} label="Upgraded On" name="upgraded_on" value={formatDate(upgrade.activated_on)} readOnly />
            </Form.Group>
            <Form.Group>
              {upgrade.upgrade_fastspring_product ? (
                <Form.Input width={8} label="FastSpring Product" name="fs_product" value={upgrade.upgrade_fastspring_product} readOnly />
              ) : null}
              {upgrade.deactivated_on ? (
                <Form.Input width={8} label="Deactivated On" name="deactivated_on" value={formatDate(upgrade.deactivated_on)} readOnly />
              ) : null}
            </Form.Group>
            {upgrade.activated_info.fastspring ? (
              <div style={{ marginBottom: "0.5rem" }}>
                <h4>FastSpring Details</h4>
                <LineItem label="Order">
                  <Label
                    as="a"
                    style={{ marginBottom: "0.25em" }}
                    target="_blank"
                    content={upgrade.activated_info.fastspring.reference}
                    href={getFsUrl("order")(upgrade.activated_info.fastspring.reference)}
                  />
                </LineItem>
                <LineItem label="Status" text={upgrade.activated_info.fastspring.status || "completed"} />
                <LineItem label="Return Status" text={upgrade.activated_info.fastspring.returned} />
                {license.deactivated_info.return ? (
                  <LineItem
                    label="Returned"
                    href={getFsUrl("return")(license.deactivated_info.return.id)}
                    text={license.deactivated_info.return.id}
                  />
                ) : null}
              </div>
            ) : null}
            {upgrade.reseller && upgrade.reseller._id ? (
              <div style={{ marginBottom: "0.5rem" }}>
                <h4>Reseller Details</h4>
                <LineItem label="Name" text={upgrade.reseller.name} onClick={() => setNavigation({ pageName: PAGES.RESELLERS, ids: [upgrade.reseller._id] })} />
                <LineItem label="Status" text={upgrade.reseller.status} />
                <LineItem label="ID" text={upgrade.reseller._id} />
                <LineItem label="Invoice Number" text={upgrade.activated_info.reseller_invoice_number} />
              </div>
            ) : null}
            {upgrade.activated_by && upgrade.activated_by._id ? (
              <div style={{ marginBottom: "0.5rem" }}>
                <LineItem label="Created by" text={upgrade.activated_by.displayname} onClick={() => setNavigation({ pageName: PAGES.USERS, ids: [upgrade.activated_by._id] })} />
              </div>
            ) : null}
          </Form>
          <Button.Group size="tiny">
            {
              canAdminLicense && lastDowngradableLicense && lastDowngradableLicense._id === upgrade._id ? (
                <Button
                  negative
                  content="Downgrade"
                  size="mini"
                  onClick={
                    confirmDowngrade(
                      onDeactivateLicenseUpgrade,
                      { licenseId: license._id, licenseUpgradeId: upgrade._id }
                    )
                  }
                />
              ) : null}
          </Button.Group>
        </Segment>
      ))}
    </Segment.Group>
  );
};

LicenseUpgradeInfo.propTypes = {
  license: licensePropType.isRequired,
  onDeactivateLicenseUpgrade: PropTypes.func.isRequired,
  setNavigation: PropTypes.func.isRequired,
};

export default LicenseUpgradeInfo;



// WEBPACK FOOTER //
// ./webAdmin/views/license/upgrades.js